import { IonPage, useIonViewDidEnter } from '@ionic/react';
import { Roles } from 'model';
import { ReactNode } from 'react';
import { TelemetryData, useTelemetryReporter } from '../hooks/useTelemetry';
import { useUserRoles } from '../hooks/useUserRoles';
import { Login } from '../pages/Login';
import { SettingsMenuDesktop } from './SettingsMenuDesktop';
import { useLoginState } from '../hooks/useLoginState';

export const QuirkIonPage: React.FC<{
	children: ReactNode;
	marginRight?: boolean;
	roles?: Roles[]; // Roles that are allowed to view this page
	name?: string; // Name of the page, setting this prop will cause the QuirkIonPage to track 'views'
	data?: TelemetryData['data']; // Telemetry data to send along with the page view
	allowLoggedOut?: boolean; // Allow logged out users to view this page
	'data-testid'?: string;
}> = ({
	children,
	marginRight = false,
	name,
	data,
	roles = ['user'],
	allowLoggedOut = false,
	'data-testid': testid
}) => {
	const reportTelemtry = useTelemetryReporter();
	const userRoles = useUserRoles();
	const loginState = useLoginState();

	useIonViewDidEnter(() => {
		// If the page has a name defined track the view
		if (name !== undefined) {
			reportTelemtry({
				actionTarget: name,
				actionType: 'viewPage',
				data
			});
		}
	});
	if (userRoles.length > 0) {
		let found = false;
		for (const role of roles) {
			if (userRoles.includes(role)) {
				found = true;
				break;
			}
		}
		if (!found && roles.length > 0) return <Login />;
	}

	// If we don't allow loggedout access, redirect to login
	if (!allowLoggedOut) {
		if (loginState.loggedIn === 'invalid') return <Login />;
	}

	return (
		<IonPage data-testid={testid}>
			<div className="gutter-container">
				<div className="gutter-left">
					<div className="gutter-margin">
						<SettingsMenuDesktop />
					</div>
				</div>
				<div className="gutter-content ion-page">
					<>{children}</>
				</div>
				<div className="gutter-right">
					{marginRight && (
						<div className="gutter-margin">
							<></>
						</div>
					)}
				</div>
			</div>
		</IonPage>
	);
};
